import Reveal from "reveal.js";
import { slideOptions } from "./slideOptions";
export function initSlides() {
    return Reveal.initialize(slideOptions);
}
